import React from 'react';

import {
  STATISTICS_SALES as FILTERS_STATISTICS_SALES,
} from '../../orders/filters';

import createChartGroup from '../createChartGroup';

import {
  Groups,
  GroupsWrapper,
  GroupsLoading,
} from '../../../components/Statistics';

import {
  filterCompare,
} from '../filters';

const GROUPS = [{
  id: 'monthlySales',
  title: 'Last 12 Months',
  sorts: [
    'default',
    'valueDsc',
    'valueAsc',
  ],
  charts: [{
    id: 'monthlySalesPerOrder',
    label: 'Orders',
    precision: 0,
    title: 'Number of orders per month.',
  }, {
    id: 'monthlySalesPerRevenue',
    label: 'Revenue',
    title: 'Total revenue per month.',
  }],
}, {
  id: 'quarterlySales',
  title: 'Last 8 Quarters',
  sorts: [
    'default',
    'valueDsc',
    'valueAsc',
  ],
  charts: [{
    id: 'quarterlySalesPerOrder',
    label: 'Orders',
    precision: 0,
    title: 'Number of orders per quarter.',
  }, {
    id: 'quarterlySalesPerRevenue',
    label: 'Revenue',
    title: 'Total revenue per quarter.',
  }],
}, {
  id: 'yearlySales',
  title: 'Last 3 Years',
  sorts: [
    'default',
    'valueDsc',
    'valueAsc',
  ],
  charts: [{
    id: 'yearlySalesPerOrder',
    label: 'Orders',
    precision: 0,
    title: 'Number of orders per year.',
  }, {
    id: 'yearlySalesPerRevenue',
    label: 'Revenue',
    title: 'Total revenue per year.',
  }],
}].map((group) => createChartGroup(group));

export default ['PageStatistics', {
  id: 'statistics-sales',
  title: 'Sales',
  label: 'Sales',
  path: '/analytics/sales',
  loadUrl: '/statistics/sales',
  redirect: [['redirect.unauthorized']],
  filters: [
    filterCompare,
    ...FILTERS_STATISTICS_SALES.map(a => ([a[0], {
      ...a[1],
      // isExtra: false,
      whereSide: 'where',
    }])),
    ...FILTERS_STATISTICS_SALES.map(a => ([a[0], {
      ...a[1],
      id: `b.${a[1].id}`,
      // isExtra: false,
      section: 'topCompare',
      whereSide: 'whereB',
      skip: [
        ...(a[1].skip || []),
        props => !['1', '2'].includes(`${props.searchParams.compare}`),
      ],
    }])),
  ],
  renderStats: (props) => {
    if (!props.data && props.loading) {
      return (
        <GroupsWrapper>
          <GroupsLoading />
        </GroupsWrapper>
      );
    }
    if (!props.data || !props.data.data) {
      return <GroupsWrapper />;
    }
    return (
      <GroupsWrapper loading={props.loading}>
        <Groups {...props} groups={GROUPS} />
      </GroupsWrapper>
    );
  },
}];
